import React from 'react';
import { observer } from 'src/utils/mobx-react';
import Loading from 'src/components/Loading';
import { REPORT_TYPES, ReportsFilterV2State } from 'src/components/Reports/ReportsFilter/ReportsFilterV2.state';
import { useAppStateContext } from 'src/AppState/AppState';
import { ReportForm } from 'src/components/Reports/ReportsFilter/ReportForm';
import { useCommon } from 'src/AppState/Common';
import { Popup } from 'src/components/Popup/Popup';

const typedKeys = <T extends Record<string, unknown>>(obj: T): (keyof T)[] => Object.keys(obj);

export const ReportsFilterV2 = observer('ReportsFilterV2', (): React.ReactElement => {
    const { reduxBackofficeUserState } = useAppStateContext();
    const common = useCommon();
    const universePrefix = reduxBackofficeUserState.universePrefix;
    const state = ReportsFilterV2State.get(common);

    return (
        <div className='reports-filter form'>
            <div className='reports-filter-filter'>
                <div
                    className={`element required hasLabel ${state.isValidReportType === false ? 'error invalid empty' : ''}`}
                >
                    <div
                        className='select-wrapper'
                        // label='Report Type'
                        // name='type'
                        data-test='report-type'
                    >
                        <select
                            // label='Report Type'
                            name='type'
                            onChange={state.onChangeReportType}
                        >
                            <option></option>
                            {typedKeys(REPORT_TYPES).map((key) => {
                                const description = REPORT_TYPES[key];
                                return (
                                    <option
                                        key={key}
                                        value={key}
                                    >
                                        {description}
                                    </option>
                                );
                            })}
                        </select>
                        <label>Report Type</label>
                    </div>
                </div>
                {state.currentReportType === 'statements' ? (
                    <div className='form-group'>
                        <div className='form-prefix-group'>
                            {universePrefix === '' ? null : (
                                <span className='form-prefix-group__label'>{universePrefix}</span>
                            )}
                            <div
                                className={`element hasLabel ${state.isValidAccountIdInput === false ? 'error invalid empty' : ''}`}
                                data-test='account-id'
                            >
                                <input
                                    name='accountId'
                                    value={state.accountIdInput.value}
                                    onChange={state.onChangeAccountIdHandler}
                                ></input>
                                <label>Account ID</label>
                            </div>
                        </div>
                    </div>
                ) : null}
                <div className='buttons'>
                    <a
                        className='btn'
                        href='#'
                        onClick={state.runReportButtonHandler}
                    >
                        Run Report
                    </a>
                    <button
                        className='btn btn-primary'
                        type='submit'
                    >
                        View Reports
                    </button>
                </div>
            </div>

            <ReportForm />

            <Popup
                title='Report generated'
                active={state.reportsReduxStore.runReport.state === 'FINISHED'}
                overlayClose={true}
                closeButton={false}
                onClose={state.onReload}
            >
                Report has been successfully generated.
                <div className='buttons'>
                    <button
                        className='btn'
                        onClick={state.onReload}
                    >
                        Ok
                    </button>
                </div>
            </Popup>

            <Popup
                title='Error occurred'
                active={state.reportsReduxStore.runReport.state === 'ERROR'}
                overlayClose={true}
                closeButton={false}
                onClose={state.onReload}
            >
                Report has not been generated.
                <div className='buttons'>
                    <button
                        className='btn'
                        onClick={state.onReload}
                    >
                        Ok
                    </button>
                </div>
            </Popup>

            <Loading
                active={state.reportsReduxStore.runReport.state === 'IN_PROGRESS'}
                message='Generating report...'
            />
        </div>
    );
});
